<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 200 200" enable-background="new 0 0 200 200" xml:space="preserve">
    <g id="Layer_2_2_">
      <path class="color" fill="#F45B5B" d="M142.154,167.286H59.027c-14.346,0-25.977-11.63-25.977-25.976V68.574
        c0-14.346,11.631-25.978,25.977-25.978h83.127c14.346,0,25.978,11.632,25.978,25.978v72.736
        C168.132,155.656,156.5,167.286,142.154,167.286z M59.027,52.987c-8.607,0-15.586,6.979-15.586,15.587v72.736
        c0,8.607,6.979,15.585,15.586,15.585h83.127c8.607,0,15.586-6.978,15.586-15.585V68.574c0-8.607-6.979-15.587-15.586-15.587H59.027
        z"/>
      <path class="color" fill="#F45B5B" d="M162.936,84.161H38.246c-2.869,0-5.195-2.326-5.195-5.195c0-2.87,2.326-5.196,5.195-5.196h124.689
        c2.869,0,5.196,2.326,5.196,5.196C168.132,81.835,165.805,84.161,162.936,84.161z"/>
      <path class="color" fill="#F45B5B" d="M74.613,63.379c-2.869,0-5.195-2.327-5.195-5.196v-20.78c0-2.87,2.326-5.195,5.195-5.195
        s5.196,2.325,5.196,5.195v20.78C79.81,61.052,77.482,63.379,74.613,63.379z"/>
      <path class="color" fill="#F45B5B" d="M126.567,63.379c-2.869,0-5.195-2.327-5.195-5.196v-20.78c0-2.87,2.326-5.195,5.195-5.195
        s5.196,2.325,5.196,5.195v20.78C131.764,61.052,129.437,63.379,126.567,63.379z"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'CalendarIcon'
}
</script>
